import {
    FormControlLabel,
    Checkbox as MuiCheckbox,
    CheckboxProps as MuiCheckboxProps
} from '@mui/material';
import clsx from 'clsx';
import React from 'react';

import classes from './Checkbox.module.scss';

interface CheckboxProps extends MuiCheckboxProps {
    label?: string;
    className?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({ label, className, ...props }) => {
    return (
        <FormControlLabel
            label={label}
            control={
                <MuiCheckbox disableRipple {...props} className={clsx(classes.root, className)} />
            }
            className={clsx(classes.root, className)}
        />
    );
};
